import { versionInfo } from "../MainPage/VersionManager";
// import { Nav, NavIcon, NavText } from "react-sidenav";
// import React from "react";
// import SvgIcon from "react-icons-kit";
import { ic_search } from "react-icons-kit/md/ic_search";
// import { ic_tv } from "react-icons-kit/md/ic_tv";
// import { insertTemplate } from "react-icons-kit/icomoon/insertTemplate";
// import { group } from "react-icons-kit/fa/group";
// import { road } from "react-icons-kit/icomoon/road";
// import permissionCheck from "utils/permissionCheck.js";
import { ic_library_books } from "react-icons-kit/md/ic_library_books";
import { ic_storage } from "react-icons-kit/md/ic_storage";
import { ic_build } from "react-icons-kit/md/ic_build";
import { spreadsheet } from "react-icons-kit/iconic/spreadsheet";
import { fileText2 } from "react-icons-kit/icomoon/fileText2";
import { server } from "react-icons-kit/fa/server";
import { stackExchange } from "react-icons-kit/fa/stackExchange";
import { time } from "react-icons-kit/ikons/time";
import { polaroid } from "react-icons-kit/ikons/polaroid";
import { clockO } from "react-icons-kit/fa/clockO";
import { wrench } from "react-icons-kit/fa/wrench";
import { chain } from "react-icons-kit/fa/chain";
import { calendarPlusO } from "react-icons-kit/fa/calendarPlusO";
// import { languageService } from "../../Language/language.service";
import { iosPaper } from "react-icons-kit/ionicons/iosPaper";
import { iosListOutline } from "react-icons-kit/ionicons/iosListOutline";
import { languageService } from "../../Language/language.service";
// if (!timpsModule) {
//   navItemsReactComp = null;
// }
import { basic_elaboration_todolist_search } from "react-icons-kit/linea/basic_elaboration_todolist_search";
export const navBarItemsSITE = [
  {
    navId: "inspection",
    navIndex: 2,
    navIcon: ic_search,
    navText: "Inspections",
    permissionCheckFirstArg: "WORKPLAN",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },

  {
    navId: "issuereports",
    navIndex: 3,
    navIcon: ic_library_books,
    navText: "Issues",
    permissionCheckFirstArg: "ISSUE",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },

  {
    navId: "maintenancebacklog",
    navIndex: 5,
    navIcon: ic_build,
    navText: "Work Order",
    permissionCheckFirstArg: "MAINTENANCE",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  // {
  //   navId: "workorders",
  //   navIndex: 5,
  //   navIcon: spreadsheet,
  //   navText: "Signal WO",
  //   permissionCheckFirstArg: "WORKORDER",
  //   permissionCheckSecondArg: "view",
  //   permissionCheck: false,
  // },

  {
    navId: "hos",
    navIndex: 10,
    navIcon: time,
    navText: "HOS",
    permissionCheckFirstArg: "HOS",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "reports",
    navIndex: 11,
    navIcon: fileText2,
    navText: "Reports",
    permissionCheckFirstArg: "REPORT",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "SiteWorkOrderReports",
    navIndex: 12,
    navIcon: iosListOutline,
    navText: "WO Reports",
    permissionCheckFirstArg: "REPORT",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "jobBriefing",
    navIndex: 12,
    navIcon: stackExchange,
    navText: "Job Briefing",
    permissionCheckFirstArg: "JOB BRIEFING",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "InspectionSchedule",
    navIndex: 13,
    navIcon: basic_elaboration_todolist_search,
    navText: "Inspection Schedule",
    permissionCheckFirstArg: "JOB BRIEFING",
    permissionCheckSecondArg: "view",
    permissionCheck: false,
  },
  {
    navId: "wims",
    navIndex: 14,
    navIcon: ic_storage,
    navText: "WIMS",
    permissionCheck: false,
    featureSetCheck: true,
    featureSetArg: "WIMS",
  },
];

export const navBarItemsTimps = [
  {
    navId: "inspection",
    navIndex: 2,
    navIcon: ic_search,
    navText: "Inspections",
    permissionCheckFirstArg: "WORKPLAN",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "ativ-data",
    navIndex: 3,
    navIcon: fileText2,
    navText: "ATIV Data",
    permissionCheckFirstArg: "ATIVData",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "issuereports",
    navIndex: 4,
    navIcon: ic_library_books,
    navText: "Issues",
    permissionCheckFirstArg: "ISSUE",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "maintenancebacklog",
    navIndex: 5,
    navIcon: ic_build,
    navText: "Work Order",
    permissionCheckFirstArg: "MAINTENANCE",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "workorders",
    navIndex: 6,
    navIcon: spreadsheet,
    navText: "Capital Plan",
    // permissionCheckFirstArg: "WORKORDER",
    // permissionCheckSecondArg: "view",
    // permissionCheck: true,
    permissionCheckFirstArg: "CAPITALPLAN",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "reports",
    navIndex: 10,
    navIcon: fileText2,
    navText: "Reports",
    // permissionCheckFirstArg: "WORKPLAN",
    // permissionCheckSecondArg: "view",
    permissionCheckFirstArg: "REPORT",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "trackChart",
    navIndex: 7,
    navIcon: server,
    navText: "Track Chart",
    permissionCheckFirstArg: "TRACKCHART",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "jobBriefing",
    navIndex: 11,
    navIcon: stackExchange,
    navText: "Job Briefing",
    permissionCheckFirstArg: "JOB BRIEFING",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "InspectionSchedule",
    navIndex: 13,
    navIcon: basic_elaboration_todolist_search,
    navText: "Inspection Schedule",
    permissionCheckFirstArg: "JOB BRIEFING",
    permissionCheckSecondArg: "view",
    permissionCheck: false,
  },
  {
    navId: "wims",
    navIndex: 14,
    navIcon: ic_storage,
    navText: "WIMS",
    permissionCheck: false,
    featureSetCheck: true,
    featureSetArg: "WIMS",
  },
];

export const navBarItemseUtility = [
  {
    navId: "inspection",
    navIndex: 2,
    navIcon: ic_search,
    navText: "Inspections",
    permissionCheckFirstArg: "WORKPLAN",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },

  {
    navId: "issuereports",
    navIndex: 3,
    navIcon: ic_library_books,
    navText: "Issues",
    permissionCheckFirstArg: "ISSUE",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "maintenancebacklog",
    navIndex: 4,
    navIcon: ic_build,
    navText: "Work Order",
    permissionCheckFirstArg: "MAINTENANCE",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "workorders",
    navIndex: 5,
    navIcon: spreadsheet,
    navText: "Capital Plan",
    permissionCheckFirstArg: "WORKORDER",
    permissionCheckSecondArg: "view",
    permissionCheck: false,
  },

  {
    navId: "reports",
    navIndex: 10,
    navIcon: fileText2,
    navText: "Reports",
    permissionCheckFirstArg: "WORKPLAN",
    permissionCheckSecondArg: "view",
    permissionCheck: false,
  },
  {
    navId: "wims",
    navIndex: 14,
    navIcon: ic_storage,
    navText: "WIMS",
    permissionCheck: false,
    featureSetCheck: true,
    featureSetArg: "WIMS",
  },
];

export const navBarItemsLITE = [
  {
    navId: "inspection",
    navIndex: 2,
    navIcon: ic_search,
    navText: "Inspections",
    permissionCheckFirstArg: "WORKPLAN",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },

  // {
  //   navId: "issuereports",
  //   navIndex: 3,
  //   navIcon: ic_library_books,
  //   navText: "Issues",
  //   permissionCheckFirstArg: "ISSUE",
  //   permissionCheckSecondArg: "view",
  //   permissionCheck: true,
  // },
  {
    navId: "maintenancebacklog",
    navIndex: 5,
    navIcon: ic_build,
    navText: "Repairs",
    permissionCheckFirstArg: "MAINTENANCE",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "reports",
    navIndex: 11,
    navIcon: fileText2,
    navText: "Reports",
    permissionCheckFirstArg: "REPORT",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "dailyReport",
    navIndex: 12,
    navIcon: clockO,
    navText: "Daily Reports",
    permissionCheckFirstArg: "REPORT",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
    webConfigArg: "dailyDisabled",
    webConfigCheck: true,
    webConfigCheckInverse: true,
  },
  {
    navId: "InspectionSchedule",
    navIndex: 13,
    navIcon: basic_elaboration_todolist_search,
    navText: "Inspection Schedule",
    permissionCheckFirstArg: "JOB BRIEFING",
    permissionCheckSecondArg: "view",
    permissionCheck: false,
  },

  {
    navId: "bluecard",
    navIndex: 11,
    navIcon: polaroid,
    navText: "Blue Card",
    permissionCheckFirstArg: "REPORT",
    permissionCheckSecondArg: "view",
    permissionCheck: false,
  },
  {
    navId: "oemlocomotive",
    navIndex: 12,
    navIcon: wrench,
    navText: "OEM Schedule",
    permissionCheckFirstArg: "REPORT",
    permissionCheckSecondArg: "view",
    permissionCheck: false,
  },
  {
    navId: "consist",
    navIndex: 13,
    navIcon: chain,
    navText: "Consist",
    permissionCheckFirstArg: "CONSIST",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "reviewsCertifications", // 1) Unique navId
    navIndex: 15, // 2) A new index that doesn't conflict
    navIcon: ic_library_books, // 3) Choose an icon
    navText: "Review & Certifications",
    permissionCheckFirstArg: "REVIEWS_CERTIFICATIONS",
    permissionCheckSecondArg: "view",
    permissionCheck: false,
  },
  {
    navId: "PIScheduler",
    navIndex: 20,
    navIcon: calendarPlusO,
    navText: "PI Scheduler",
    permissionCheckFirstArg: "PI",
    permissionCheckSecondArg: "view",
    permissionCheck: true,
  },
  {
    navId: "wims",
    navIndex: 14,
    navIcon: ic_storage,
    navText: "WIMS",
    permissionCheck: false,
    featureSetCheck: true,
    featureSetArg: "WIMS",
  },
];



// WEBPACK FOOTER //
// ./src/components/SideNavBar/timps.Nav.jsx